import { ICareerExercise, ICareerExerciseField } from './transformCareerExercise';

export type ExerciseValues = Record<string, unknown>;

/**
 * ТЗ 0039 — начальные значения формы анкеты.
 *
 * 🔴 Порядок источников несущий: сначала уже сданный ответ, и только если
 * сдачи не было — подсказка сервера. Наоборот было бы хуже всего: повторное
 * открытие урока показало бы студенту не то, что он выбрал, а пересдача молча
 * переписала бы его навыки предложением сервера.
 */
export const buildExerciseInitialValues = (exercise: ICareerExercise): ExerciseValues =>
  exercise.fields.reduce<ExerciseValues>((acc, field) => {
    const answered = exercise.answers ? exercise.answers[field.id] : undefined;
    acc[field.id] = answered !== undefined && answered !== null ? answered : fallback(field);
    return acc;
  }, {});

const fallback = (field: ICareerExerciseField): unknown => {
  if (field.prefill !== null && field.prefill !== undefined) {
    return field.prefill;
  }
  switch (field.fieldType) {
    case 'yes_no':
      return false;
    case 'rating':
      return null;
    case 'single_choice':
      return null;
    case 'multi_choice':
    case 'skills':
    case 'repeat_group':
      return [];
    case 'month_year':
      return { year: null, month: null };
    default:
      return '';
  }
};

/** Пусто ли значение — то же понимание, что у сервера. */
export const isExerciseValueEmpty = (field: ICareerExerciseField, value: unknown): boolean => {
  if (value === null || value === undefined || value === '') return true;
  if (Array.isArray(value)) return value.length === 0;
  if (field.fieldType === 'month_year') {
    return !(value as { year?: number | null })?.year;
  }
  if (typeof value === 'string') return !value.trim();
  return false;
};

/**
 * Значения формы → аргумент мутации. `JSON.stringify` живёт ЗДЕСЬ, а не в
 * компоненте: кодировка — свойство контракта, и размазывать её по виджетам
 * значит однажды закодировать один тип иначе, чем остальные.
 */
export const buildExerciseAnswers = (
  exercise: ICareerExercise,
  values: ExerciseValues,
): { fieldId: string; value: string }[] =>
  exercise.fields.map((field) => ({
    fieldId: field.id,
    value: JSON.stringify(values[field.id] ?? null),
  }));
